<template>
  <ut-form :label-width="200">
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 说明：
      </template>
      <ut-alert
        type="warn"
        :style="{width:'500px'}"
      >业务异常埋点产生的报警,默认报警策略为(邮件方式报警;10分钟最多3次,1小时最多10次,1天最多30次),如果默认策略不满足需求,可以在这里定制报警策略。</ut-alert>
    </ut-form-item>

    <ut-input placeholder="业务Key" v-show="false" v-model="id" readonly :style="{width:'500px'}"></ut-input>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 业务Key：
      </template>
      <ut-input placeholder="业务Key" v-model="alarmKey" :style="{width:'500px'}"></ut-input>
      <ut-alert
        type="warn"
        :style="{width:'500px'}"
      >业务Key指的是业务异常埋点上报的Key,假设使用@SimpleMetric埋点,业务Key就是注解中传入的Key;假设使用ArgusReporter上报业务异常,业务Key就是传入的第一个参数!</ut-alert>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 报警策略：
      </template>
      <ut-select v-model="policyId" :style="{width:'500px'}">
        <ut-option v-for="item in selectedPolicys" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>
    <ut-form-item>
    <template slot="label">
        <span style="color:red">*</span> 负责人
      </template>
      <ut-select v-model="userIds" multiple filterable :style="{width:'500px'}" :filter-method='filter'>
        <ut-option v-for="item in selectedSearchUsers||selectedUser" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即更新</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data() {
    return {
        alarmKey:'',
        selectedPolicys:[],
        policyId:'',
        userIds:'',
        id: '',
        selectedSearchUsers:null,
        selectedUser:[]
    }
  },
  methods:{
    submit(){
      var alarmKey = this.alarmKey;
      var alarmPolicyId = this.policyId;
      var alarmUserIds = this.userIds

      if(alarmKey == ""){
        this.$message.error('报警应用key 不能为空!');
        return false;
      }
      if(alarmPolicyId == ""){
        this.$message.error('报警策略名称不能为空！');
        return false;
      }
      if(alarmUserIds == "") {
        this.$message.error("负责人 不能为空！");
        return false;
      }

      var sendData = {};
      sendData.alarmKey = this.alarmKey;
      sendData.alarmPolicyId = this.policyId;
      sendData.id = this.id;
      sendData.userIds = this.userIds;
      console.log(sendData)
      this.$http({
        method: "post",
        url: "bizs/update.htm",
        data: JSON.stringify(sendData)
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          if(response.data.code == 0){
            this.$message.success('更新成功');
            var callbackUrl = this.$route.query.callbackUrl;
            if(callbackUrl){
             this.$router.push({ path: callbackUrl });
            }else{
             this.$router.push({ path: "/bizs" });
            }
          }else{
            this.$message.error(response.data.message);
            return false;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    goBack(){
      var callbackUrl = this.$route.query.callbackUrl;
      if(callbackUrl){
       this.$router.push({ path: callbackUrl });
      }else{
       this.$router.push({ path: "/bizs" });
      }
    },
    filter (val) {
      const data = []
      const inp = val && val.toLowerCase()
      this.selectedUser.map(item => {
        if (item.name.includes(inp) || item.id.toLowerCase().includes(inp)) {
          data.push(item)
        }
      })
      if (data.length) {
        this.selectedSearchUsers = data
      } else {
        this.selectedSearchUsers = null
      }
    }
  },
    created() {
      this.$http({
        method: "post",
        url: "policys/list.htm",
        data: "{}"
      })
        .then(response => {
          //这里使用了ES6的语法
          this.selectedPolicys = response.data;
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });

        this.$http({
          method: "post",
          url: "users/list.htm",
          data: "{}"
        })
          .then(response => {
            //这里使用了ES6的语法
            console.log(response); //请求成功返回的数据
            this.selectedUser = response.data;
          })
          .catch(error => {
            console.log(error); //请求失败返回的数据
          });

      this.$http({
        method: "post",
        url: "bizs/"+this.$route.query.id+"/get.htm",
        data: "{}"
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response.data)
          this.alarmKey = response.data.alarmKey;
          this.policyId = response.data.alarmPolicyId;
          this.id = response.data.id;
          if(response.data.userIds != undefined){
            this.userIds = response.data.userIds;

            var users = "";
            for (var r = 0;r < response.data.userIds.length; r ++){
              users += response.data.userIds[r].id + ",";
            }
            var index = 0;
            var userStr = users.split(",");
            console.log("users : " + users)
            console.log(userStr)
            for (var n = 0;n < this.selectedUser.length; n ++){
              for(var a = 0;a < userStr.length; a++){
                if(parseInt(userStr[a]) === this.selectedUser[n].id){
                  console.log(this.selectedUser[n])
                  temp[index] = this.selectedUser[n].name;
                  value[index] = this.selectedUser[n].id;
                  index ++;
                }
              }
            }
            this.userIds = value;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    }

}
</script>
